<template>
          <v-dialog v-model="show" max-width="580" :fullscreen="$vuetify.breakpoint.xs" scrollable>
            <v-card>
                <v-card-title class="headline primary--text fixNotchPaddingTop rundown-dialog-head">
                {{$t('NEW_ANNOUNCEMENT_TITLE')}}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>


        <v-container>
            <v-form  dense ref="form" v-bind:disabled="loading">
              <v-row> 
                <v-col cols="12">
                  <v-text-field  v-bind:disabled="loading"
                    v-model="announcement.title"
                    :rules="[validationRules.required]"
                    :label="$t('NEW_ANNOUNCEMENT_FIELD_TITLE')"/>
                </v-col> 
                <v-col cols="12">
                  <v-text-field v-bind:disabled="loading"
                    v-model="announcement.message" 
                    :label="$t('NEW_ANNOUNCEMENT_FIELD_MESSAGE')"/>
                </v-col> 
                <v-col cols="12">
                  <v-text-field prepend-icon="mdi-export"
                    v-model="announcement.link"  v-bind:disabled="loading"
                    :rules="[validationRules.url]"
                    :label="$t('NEW_ANNOUNCEMENT_FIELD_LINK')"/>
                </v-col> 
                <v-col cols="12">
                  <v-file-input
                        :label="$t('NEW_ANNOUNCEMENT_FIELD_ATTACHMENT')" 
                        v-model="file" ref="file"   
                        prepend-icon="mdi-link-variant"
                        v-bind:disabled="loading">
                    </v-file-input>
                </v-col> 
                <v-col cols="12" md="6">
                 <v-checkbox v-model="announcement.priority" 
                    :label="$t('NEW_ANNOUNCEMENT_FIELD_IMPORTANT')" 
                    v-bind:disabled="loading"></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                    <v-checkbox v-model="announcement.notify" 
                      :label="$t('NEW_ANNOUNCEMENT_FIELD_NOTIFY')"
                      v-bind:disabled="loading"></v-checkbox>
                </v-col>
            </v-row>

            </v-form>
          </v-container>


            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="fixNotchPaddingBottom">
                <v-spacer></v-spacer>
              <v-btn color="secondary rundown-dialog-btn" @click="sendAnnouncement" :loading="loading">{{$t('NEW_ANNOUNCEMENT_SEND')}}</v-btn> 
              <v-btn color="primary rundown-dialog-btn" text @click="close()">{{$t('NEW_ANNOUNCEMENT_CLOSE')}}</v-btn> 
             </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
 import BaseModule from './BaseModule'
  export default {
    name: 'NewAnnouncmentDialog', 
    mixins: [BaseModule],
    props: [],
    data(){
        return {  
             show: false,
             file: null,
             loading: false,
             announcement: {
                 title: null,
                 message: null,
                 priority: false,
                 notify: true,
                 link:null
             },
             user: {
                 id: null
             },
             rundown: {
                 announcementChecked: null,
                 userId: null,
                 parentId: null
             }, 
        }

    },  
    updated: function() {
        // fix for v-file-input not triggering properly

        setTimeout(() => {
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            }) 
        }, 1000);
        
    },
    methods: { 
       close()
        {
            this.show=false
            window.rundownApp.device.backButtonCallback = null;
        },
        sendAnnouncement() {

            if (!this.$refs.form.validate()) {
              return;
            }

            this.loading=true;
            let formData = new FormData();
            let me = this;
            formData.append('file', this.file?this.file:null);
            formData.append('rundownId',this.rundown.rundownId);
            formData.append('fileName',this.file?this.file.name:'');
            formData.append('mimeType',this.file?this.file.type:'');
            formData.append('title',this.announcement.title);
            formData.append('rundownName',this.rundown.title);

            if (this.announcement.message)
                formData.append('message',this.announcement.message);

            if (this.announcement.link)
                formData.append('link',this.announcement.link);

            formData.append('priority',this.announcement.priority);
            formData.append('notify',this.announcement.notify);
            window.rundownApp.api.createAnnouncement(formData,
            function(res){
                    me.loading=false;
                    console.log(res);
                    me.close();
                    window.rundownApp.channel.sendRundownListUpdated();
                }
            ,function(error){
                    me.loading=false;
                    me.$refs.file.errorMessages="Se ha producido un error al subir este documento.";
                    console.log(error);
                    me.file=null;
            });
        },
        createAnnouncement(user,rundown)
        {  
            this.show=true;
            console.log(rundown);
            this.loading=false;
            this.rundown=rundown;
            this.user=user;
            this.announcement={};
            this.announcement.notify=true;
            this.file=null;

            window.rundownApp.device.backButtonCallback = this.close;
        } 
      },
  }
</script>